import { IActiveId } from "@/lib/widgetsLayoutDir";
import importBlocksAndAllocationsStore from "@/store/importBlocksAndAllocationsStore";
import tradeBlockDataStore from "@/store/tradeBlockDataStore";
import tradeDataStore from "@/store/tradeDataStore";
import SwapCurveHandler from "./SwapCurveHandler";

// LQC-1607 — Swap Curve widget entry point. Reads the trade + Creation block stores and
// hands them to the handler, which renders the trade selector and accepts dropped
// swap trades (ESIDs) and swap blocks. See README.md for the full flow.
interface ISwapCurveIndex {
  cryptoID?: string;
  loadedFromPopout?: boolean;
  esidToPass?: string;
  activeId?: Partial<IActiveId>;
}

const SwapCurveIndex = ({ cryptoID, activeId }: ISwapCurveIndex) => {
  // tradeData (ExecutionStrategy[]) feeds both the selector and swap detection — a trade's
  // blocks are its legs (RP: trade.legs, OP: executionRequestCounterParties[].legs).
  const tradeData = tradeDataStore((state) => state.tradeData);
  const allBlocks = importBlocksAndAllocationsStore((state) => state.allBlocks);
  // Assigned blocks per ESID: the only source of a New trade's per-block mid + maturity (LQC-2908).
  const tradeBlockData = tradeBlockDataStore((state) => state.tradeBlockData);

  return (
    <SwapCurveHandler
      cryptoID={cryptoID}
      activeId={activeId}
      tradeData={tradeData}
      allBlocks={allBlocks}
      tradeBlockData={tradeBlockData}
    />
  );
};

export default SwapCurveIndex;
